export const PRESETS = {
  ambient_loop: {
    name: 'Ambient Loop',
    description: 'Slow, dreamy crossfades with shuffled imagery. Ideal for sleep videos and ambient backgrounds.',
    image_duration: 10,
    transition_duration: 1.0,
    sequencing: 'shuffle',
  },
  luxury_showcase: {
    name: 'Luxury Showcase',
    description: 'Clean linear presentation with quick transitions. Perfect for product showcases and portfolios.',
    image_duration: 7,
    transition_duration: 0.5,
    sequencing: 'linear',
  },
  deep_nostalgia: {
    name: 'Deep Nostalgia',
    description: 'Lingering holds with gentle fades. Great for meditation content and nostalgic slideshows.',
    image_duration: 12,
    transition_duration: 1.5,
    sequencing: 'linear',
  },
};
